module.exports = __webpack_public_path__ + "assets/images/Order_Type_S_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_S_Icon.png
// module id = 1427
// module chunks = 1